export const MAP_API = process.env.REACT_APP_MAP_API || '';
// export const BASE_URL = 'http://localhost:8008';
export const BASE_URL = 'https://copper-depot-451609-d5.ue.r.appspot.com/'